import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function DocMeta({ tags, children }) {
  return (
    <>
      <Helmet>
        {tags?.map((tag, index) => {
          if (tag.name === 'title') {
            return <title key={index}>{tag.content}</title>;
          }
          return <meta key={index} {...tag} />;
        })}
      </Helmet>
      {children || null}
    </>
  );
}

